var Layout    = require("enyo/Layout"),
    dom       = require("enyo/dom"),
    kind      = require("enyo/kind"),
    themeVars = require("app/theme/variables");

module.exports = kind(/** @lends  app.ui.header.CompactHeaderLayout.prototype */ {

    /**
     * @private
     */
    name: "app.ui.header.CompactHeaderLayout",

    /**
     * @private
     */
    kind: Layout,

    /**
     * @public
     */
    reflow: function() {
        var $container       = this.container,
            $title           = $container.$.title,
            $playMediaButton = $container.$.playMediaButton,
            $signUpButton    = $container.$.signUpButton,
            $bookmarkButton  = $container.$.bookmarkButton,
            $shareButton     = $container.$.shareButton,
            containerNode    = $container.hasNode(),
            buttons,
            containerBounds,
            containerPadding,
            titleBounds,
            titleFontSize,
            titleLineHeight,
            titleLines,
            lineSpace,
            buttonHeight,
            allButtonsWidth,
            offsetTop,
            offsetLeft,
            offsetRight,
            titleBottom,
            buttonsBottom;

        if (!containerNode) {
            return;
        }

        // Buttons to arrange
        buttons = [$playMediaButton, $signUpButton, $bookmarkButton, $shareButton].filter(function($button) {
            return $button.get("showing");
        }).map(function($button) {
            var buttonBounds = $button.getBounds();

            return {
                control: $button,
                width:   buttonBounds.width,
                height:  buttonBounds.height,
                right:   null
            };
        });

        // Dimensions
        containerBounds  = $container.getBounds();
        containerPadding = dom.calcPaddingExtents(containerNode);
        titleBounds      = $title.getBounds();
        titleFontSize    = parseFloat($title.getComputedStyleValue("font-size"), 10);

        if (titleBounds.height > 0) {
            titleLineHeight = parseFloat($title.getComputedStyleValue("line-height"), 10);
        }
        else {
            titleLineHeight = 0;
        }

        if (titleBounds.height > 0 &&  titleLineHeight > 0) {
            titleLines = Math.round(titleBounds.height / titleLineHeight);
        }
        else {
            titleLines = 0;
        }
        lineSpace       = containerBounds.width - containerPadding.left - containerPadding.right;
        buttonHeight    = buttons.length ? buttons[0].height : 0;
        allButtonsWidth = buttons.length
            ? buttons.reduce(function(total, button) {
                return total + button.width + themeVars.getButtonSpacingHorizontalPx();
            }, 0) - themeVars.getButtonSpacingHorizontalPx()
            : 0;

        // Alignment
        // ----------------

        // Only buttons, no title.
        if (titleLines === 0) {
            if (buttons.length) {
                offsetTop     = containerPadding.top;
                offsetRight   = containerPadding.right;
                buttons.forEach(function(button) {
                    button.control.addStyles({
                        top:   offsetTop + "px",
                        left:  "initial",
                        right: offsetRight + "px"
                    });
                    offsetRight += button.width + themeVars.getButtonSpacingHorizontalPx();
                });
                buttonsBottom = offsetTop + buttons[0].height;
            }
        }

        // If all buttons fit next to a single-line title we'll align them to
        // the right of the title.
        else if (titleLines === 1
            && titleBounds.width + themeVars.getContentPaddingHorizontalPx() + allButtonsWidth <= lineSpace) {

            // Title is taller than the buttons
            if (titleLineHeight > buttonHeight) {

                // Align title
                offsetTop   = containerPadding.top;
                offsetLeft  = containerPadding.left;
                $title.addStyles({
                    top:  offsetTop + "px",
                    left: offsetLeft + "px"
                });
                titleBottom = offsetTop + titleBounds.height;

                // Align buttons with a slight offset at the top
                if (buttons.length) {
                    offsetTop     = containerPadding.top + (titleLineHeight - buttonHeight) / 2;
                    offsetRight   = containerPadding.right;
                    buttons.reverse().forEach(function(button) {
                        button.control.addStyles({
                            top:   offsetTop + "px",
                            left:  "initial",
                            right: offsetRight + "px"
                        });
                        offsetRight += button.width + themeVars.getButtonSpacingHorizontalPx();
                    });
                    buttonsBottom = offsetTop + buttons[0].height;
                }
            }
            else {
                // Align title with a slight offset at the top
                offsetTop   = containerPadding.top + (buttonHeight - titleLineHeight) / 2;
                offsetLeft  = containerPadding.left;
                $title.addStyles({
                    top:  offsetTop + "px",
                    left: offsetLeft + "px"
                });
                titleBottom = offsetTop + titleBounds.height;

                // Align buttons
                if (buttons.length) {
                    offsetTop     = containerPadding.top;
                    offsetRight   = containerPadding.right;
                    buttons.forEach(function(button) {
                        button.control.addStyles({
                            top:   offsetTop + "px",
                            left:  "initial",
                            right: offsetRight + "px"
                        });
                        offsetRight += button.width + themeVars.getButtonSpacingHorizontalPx();
                    });
                    buttonsBottom = offsetTop + buttons[0].height;
                }
            }
        }

        // Otherwise, fill buttons below the title, starting from the left
        else {

            // Align title
            offsetTop   = containerPadding.top;
            offsetLeft  = containerPadding.left;
            $title.addStyles({
                top:  offsetTop + "px",
                left: offsetLeft + "px"
            });
            titleBottom = offsetTop + titleBounds.height;

            // Align buttons
            if (buttons.length) {
                offsetTop     = titleBottom - (titleLineHeight - titleFontSize) / 2 + themeVars.getButtonSpacingVerticalPx();
                offsetLeft    = containerPadding.left;
                buttons.forEach(function(button) {
                    // Next line
                    if (lineSpace + containerPadding.left < offsetLeft + button.width) {
                        offsetTop  = buttonsBottom + themeVars.getButtonSpacingVerticalPx();
                        offsetLeft = containerPadding.left;
                    }

                    // Button alignment
                    button.control.addStyles({
                        top:   offsetTop + "px",
                        left:  offsetLeft + "px",
                        right: "initial"
                    });

                    // Update offset and bottom
                    offsetLeft    += button.width + themeVars.getButtonSpacingHorizontalPx();
                    buttonsBottom = offsetTop + button.height;
                });
                buttonsBottom += (titleLineHeight - titleFontSize) / 2;
            }
        }

        if (titleLines === 0) {
            titleBottom = 0;
        }

        if (buttons.length === 0) {
            buttonsBottom = 0;
        }

        $container.applyStyle("height", Math.max(titleBottom, buttonsBottom, containerPadding.top) + containerPadding.bottom + "px");
    }

});
